// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBVe3WQUZCXIHkv3HWNjik1-XqdYsszqpY",
  authDomain: "fyndura.firebaseapp.com",
  projectId: "fyndura",
  storageBucket: "fyndura.firebasestorage.app",
  messagingSenderId: "362305566606",
  appId: "1:362305566606:web:839c523bb369e2a576d6df",
  measurementId: "G-R536WE4V8V"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// 🔹 Request Notification Permission & Get Token
export const requestForToken = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey:
        "BJxK76056ecl576h_QDSXuOxfSw3x_2xSMQJE9EpN-hfcHy-vnQ5-e-pSAegsK3HJF4Cy9yrn0qcjKy17pJc-bo"
    });
    if (token) {
      localStorage.setItem("fcToken", token);
      // console.log("✅ FCM Token:", token);
    };
    
  } catch (err) {
    console.error("⚠️ Error getting token:", err);
  }
};

// 🔹 Listen for foreground messages (returns unsubscribe function)
export const listenForMessages = (callback) => {
  return onMessage(messaging, callback); // this is where unsubscribe comes from
};

export default app;
